import * as p from '@clack/prompts'

export function printNextSteps(options: {
  reviewLabel: string
  needsMigration: boolean
  route: string
}): void {
  const steps = [`1. Review ${options.reviewLabel}`]
  if (options.needsMigration) {
    steps.push('2. Run database migration: db:push')
    steps.push(`3. Start the dev server and visit ${options.route}`)
  } else {
    steps.push(`2. Start the dev server and visit ${options.route}`)
  }
  p.note(steps.join('\n'), 'Next steps')
}
